import styled, { css } from 'styled-components';
import { darken } from 'polished';

export const Wrapper = styled.div`
  max-width: 950px;
  width: 100%;
  margin: 0 auto;
`;

Wrapper.NotFound = styled.span`
  display: block;
  width: 100%;
  text-align: center;

  font-size: 14px;
  font-style: italic;
  color: rgba(44, 64, 90, 0.5);
  padding: 40px 0;
`;

export const Action = styled.div`
  align-self: center;

  > button {
    background: none;
    border: 0;

    color: #2c405a;

    transition: color 1s;

    + button {
      margin-left: 10px;
    }

    :hover {
      color: ${darken(0.05, '#2c405a')};
    }
  }
`;

export const Table = styled.table`
  border-collapse: separate;
  border-spacing: 0 20px;
  width: 100%;

  font-size: 14px;

  padding: 5px 0;

  > tbody {
    > tr {
      > td {
        text-align: left;
        vertical-align: top;
        border: 1px solid #cbd0d8;
        border-radius: 5px;
        background: #fff;
        color: #2c405a;
      }
    }
  }

  > tfoot {
    > tr {
      display: flex;

      > td {
        flex: 1;

        > button {
          border: 0;
          background: none;
          border-radius: 5px;
          color: #2c405a;
          height: 32px;
          width: 100%;
          transition: 1s all;

          :hover {
            color: #fff;
            background: #ff5a22;
          }
        }
      }
    }
  }
`;

Table.Container = styled.tr`
  > td {
    ${(props) =>
      props.cancelled &&
      css`
        border: 1px solid #de3b3b !important;
      `}
  }
`;

Table.Wrapper = styled.div`
  position: relative;
  flex: 1;

  strong {
    font-size: 12px;
    text-transform: uppercase;
  }

  span {
    font-size: 12px;

    + span {
      margin-top: 5px;
    }
  }
`;

Table.Header = styled.header`
  padding: 10px 20px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom: 2px solid #cbd0d8;
  display: flex;

  button {
    background: none;
    border: 0;
    color: #cbd0d8;
    transition: color 1s;

    & + button {
      margin-left: 10px;
    }
  }
`;

Table.Header.BtnPrint = styled.button`
  :hover {
    color: #2c405a;
  }
`;

Table.Header.BtnCancel = styled.button`
  :hover {
    color: #de3b3b;
  }
`;

Table.Content = styled.table`
  padding: 15px 20px;
  width: 100%;
`;

Table.Row = styled.div`
  display: flex;
  padding: 5px 10px;

  button {
    background: none;
    border: 0;
    color: #cbd0d8;
    transition: color 1s;
  }

  ${(props) =>
    props.withBackground &&
    css`
      background: #cbd0d8;
      border: 1px solid #cbd0d8;
      border-radius: 5px;
    `}

  ${(props) =>
    props.withFlex &&
    css`
      flex: 1;
    `}

  ${(props) =>
    props.withCenter &&
    css`
      align-items: center;
      justify-content: center;
    `}
`;

Table.Row.Cancel = styled.span`
  color: #de3b3b;
  font-weight: bold;
  font-style: italic;
  /* padding: 5px; */
`;

Table.Row.BtnCancel = styled.button`
  :hover {
    color: #de3b3b;
  }
`;

Table.Icon = styled.div`
  padding: 5px 20px 5px 0;
`;

Table.Col = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 5px 0 10px;

  span {
    white-space: pre-line;
  }
`;
